import React from "react";
import { Controller } from "react-hook-form";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";

const qualifications = [
  {
    id: "basiceInterpreting",
    label:
      "Basic Interpreting (Eg: Community Interpreting Level 1, Introduction to the Criminal Justice System, other)",
  },
  { id: "levelTwo", label: "Community Interpreting Level 2" },
  { id: "levelThree", label: "Community Interpreting Level 3" },
  { id: "levelSix", label: "Community Interpreting Level 4 - 6" },
  {
    id: "dpiFormerly",
    label:
      "DPI (Formerly Metropolitan Police test)- Unit Pass – (Diploma in Police Interpreting)",
  },
  {
    id: "dpsiHealth",
    label: "DPSI (Health) Partial – (Diploma in Public Service Interpreting)",
  },
  {
    id: "dpsiLaw",
    label: "DPSI (Law) Unit Pass – (Diploma in Public Service Interpreting)",
  },
  {
    id: "dpsiLocalGovt",
    label:
      "DPSI (Local Govt.) Partial – (Diploma in Public Service Interpreting)",
  },
  {
    id: "indHomeOffice",
    label: "IND (Home Office) – (Immigration Nationality Directorate)",
  },
  { id: "ukBorderAgency", label: "UK Border Agency Certificate" },
  { id: "languageRelatedDegree", label: "Language related degree or diploma" },
  { id: "nrpsi", label: "NRPSI" },
  { id: "otherOne", label: "Other", isOther: true, textLabel: "otherTextOne" },
  { id: "otherTwo", label: "Other", isOther: true, textLabel: "otherTextTwo" },
];

export default function QualificationTable({ control }) {
  return (
    <>
      <Typography style={{ marginBottom: 10 }}>
        Do you posses one or more interpreting qualifications from the list
        below? Please tick
      </Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell width="80">S No.</TableCell>
              <TableCell>Qualification / Accreditation</TableCell>
              <TableCell align="center" width="100">
                Select
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {qualifications.map((q, index) => (
              <TableRow key={q.id}>
                <TableCell>{index + 1}</TableCell>

                <TableCell>
                  {q.isOther ? (
                    <Controller
                      name={q.textLabel}
                      control={control}
                      defaultValue=""
                      render={({ value, onChange }) => (
                        <TextField
                          value={value || ""}
                          onChange={onChange}
                          placeholder="Other -"
                          size="small"
                          fullWidth
                          variant="outlined"
                        />
                      )}
                    />
                  ) : (
                    q.label
                  )}
                </TableCell>

                <TableCell align="center">
                  <Controller
                    name={q.id}
                    control={control}
                    defaultValue={false}
                    render={({ value, onChange }) => (
                      <Checkbox
                        checked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                        color="primary"
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
